/**
 * Postgres table/resource names used by the generic single-order-details endpoint.
 *
 * @module singleOrderDetailsTableName
 */
export enum SingleOrderDetailsTableName {
  COVERAGE = "coverage",
  WORKFLOW_CONFIG = "workflow-config",
  MEDICAL_PA_ORDER_GENERAL_INFO = "order",
  AUTH_ON_FILE = "order-auth",
  CLINICAL_DATA = "clinical-data",
  ORDER_COMMENTS = "order-comments",
  /** Order review records (approved/rejected review submissions). */
  REVIEWS = "reviews",
  CLINICAL_CONDITIONS = "clinical-data",
  AUTHORIZATION = "authorization",
  SUBMISSION = "submission",
  AUTH_STATUS_COMMENTS = "auth-status-comments",
  ORDER_STATUS = "order-status",
}
